// A red edge vignette pulsing with the heartbeat while `active` (the last seconds of the countdown).
// One fixed layer; opacity only; the beat follows `bpm`. Reduced motion: a steady, faint vignette.
import { createPortal } from 'react-dom';
import { useReducedMotion } from './reduced';

export function PulseVignette({ active, bpm = 110 }: { active: boolean; bpm?: number }) {
  const reduced = useReducedMotion();
  if (typeof document === 'undefined') return null;
  const beat = `${(60 / Math.max(30, Math.min(220, bpm))).toFixed(3)}s`;
  return createPortal(
    <div aria-hidden="true" data-active={active || undefined}
      style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 55, opacity: active ? 1 : 0, transition: 'opacity 320ms ease', willChange: 'opacity' }}>
      <div style={{
        position: 'absolute', inset: 0,
        background: 'radial-gradient(ellipse 120% 95% at 50% 50%, transparent 52%, rgb(229 54 75 / 0.16) 74%, rgb(229 54 75 / 0.42) 100%)',
        animation: active && !reduced ? `rd-vignette-beat ${beat} ease-in-out infinite` : undefined,
        opacity: reduced ? 0.6 : undefined,
      }} />
    </div>,
    document.body,
  );
}
